import { Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import MDBox from "components/MDBox";
import { JobPhase } from "generated/graphql";
import { denseTableSx, headerCellSx } from "./utils";

export default function AdditionalCostsTable({ jobPhase }: { jobPhase: JobPhase }) {
  if ((jobPhase?.proposalProduct?.additionalCosts?.length ?? 0) === 0) {
    return null;
  }

  return (
    <MDBox>
      <TableContainer component={Paper}>
        <Table aria-label="additional costs" sx={denseTableSx}>
          <TableBody>
            <TableRow>
              <TableCell variant="head" sx={headerCellSx}>
                Additional Cost
              </TableCell>
              <TableCell variant="head" align="right" width="72px" sx={headerCellSx}>
                Quantity
              </TableCell>
            </TableRow>
            {jobPhase?.proposalProduct?.additionalCosts?.map((additionalCost) => (
              <TableRow key={additionalCost?.id}>
                <TableCell>{additionalCost?.name}</TableCell>
                <TableCell align="right">
                  {additionalCost?.quantityOverride || additionalCost?.quantity}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </MDBox>
  );
}
